import { render, staticRenderFns } from "./Http404.vue?vue&type=template&id=f4c1c7b0"
import script from "./Http404.vue?vue&type=script&lang=js"
export * from "./Http404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports